import { CodeCanvasModel } from "./code-canvas";

export default CodeCanvasModel.extend({
  constructor(attr, options) {
    attr = attr || {};
    attr.isForeground = true;
    return CodeCanvasModel.prototype.constructor.call(this, attr, options);
  },
});
